import { Injectable } from '@angular/core';
import { Rutas } from '../../utiles/Rutas';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { PageService } from '../../page/services/page.service';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private pageService: PageService
  ) {}

  forgotPassword(value: any): any {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(
      Rutas + 'public/update_password',
      JSON.stringify(value),
      {
        headers,
      }
    );
  }

  login(e: string, p: string): any {
    this.pageService.setEstadisticas(undefined, undefined);
    this.pageService.setExpedientes(undefined);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const json = JSON.stringify({ username: e, password: p });
    return this.http.post(Rutas + 'users/login_check', json, { headers });
  }

  getToken(): any {
    return sessionStorage.getItem('token');
  }

  loggedIn(): any {
    return sessionStorage.getItem('token');
  }

  logout(): any {
    sessionStorage.clear();

    return this.router.navigate(['/public/login/'], { relativeTo: this.route });
  }

  passwordsIguales(password: string, password2: string): any {
    return (formGroup: FormGroup) => {
      const pass1Control = formGroup.controls[password];
      const pass2Control = formGroup.controls[password2];
      if (pass1Control.value === pass2Control.value) {
        pass2Control.setErrors(null);
      } else {
        pass2Control.setErrors({ noEsIgual: true });
      }
    };
  }

  updatePassword(email: string, password: string): any {
    console.log('PASSWORD', password);
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post<any>(
      Rutas + 'update_password',
      JSON.stringify({ email: email, password: password }),
      { headers, responseType: 'text' as 'json' }
    );
  }
}
